import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import axios from 'axios';
import config from '../config';
import CharacterForm from './CharacterForm';
import { CircularProgress, Box } from '@mui/material';

const EditCharacter: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { getAccessTokenSilently } = useAuth0();
  const [character, setCharacter] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCharacter = async () => {
      if (!location.state?.character?._id) {
        navigate('/my-characters');
        return;
      }

      try {
        const token = await getAccessTokenSilently();
        const response = await axios.get(
          `${config.api.baseURL}/api/characters/${location.state.character._id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }
        );
        setCharacter(response.data);
      } catch (error) {
        console.error('Error fetching character:', error);
        navigate('/my-characters');
      } finally {
        setLoading(false);
      }
    };

    fetchCharacter();
  }, [location.state?.character?._id, getAccessTokenSilently, navigate]);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
        <CircularProgress />
      </Box>
    );
  }

  if (!character) {
    return null;
  }

  return <CharacterForm initialCharacter={character} isEditing={true} />;
};

export default EditCharacter; 